import { gql } from "@apollo/client";

const USERS_SUBSCRIPTION = gql`
  subscription UserSubscribed($clientId: Int) {
    userSubscriptions(clientId: $clientId) {
      userId
      subscriptionId
      subscriptionType
      subscribedId
      action
    }
  }
`;

export default USERS_SUBSCRIPTION;
